import { useEffect, useState, useRef } from "react";



import you from '../../assets/images/boy.png';
import bot from '../../assets/images/happy.png';
import Mainmenu from "../../components/ChatFlow/MainMenu";

const Details = () => {
  const [name, setName] = useState('');
  const [mobile, setMobile] = useState('');

  const [showFrame, setShowFrame] = useState(false);
  const [showFrame1, setShowFrame1] = useState(false);

  const [showInput, setShowInput] = useState(true);
  const [showInput1, setShowInput1] = useState(false);

  const [time, setTime] = useState(null);
  const [time1, setTime1] = useState(null);

  const nameInputRef = useRef(null);
  const mobileInputRef = useRef(null);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (nameInputRef.current) {
      nameInputRef.current.focus();
    }
  }, []);

  useEffect(() => {
    if (showInput1 && mobileInputRef.current) {
      mobileInputRef.current.focus();
    }
  }, [showInput1]);

  useEffect(() => {
    setTimeout(() => setLoading(false), 2000);
  }, []);

  const handleChange = (e) => {
    const value = e.target.value;
    if (/^[A-Za-z\s]*$/.test(value)) {
      setName(value);
    } else {
      alert('Please enter a valid name');
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (name.length === 0) {
      alert('Please Enter Your Name');
      return;
    }
    setTime(new Date());
    setShowFrame(true);
    setShowInput(false);
    setShowInput1(true);
  };

  const handleChange1 = (e) => {
    const value = e.target.value;
    if (/^[0-9]*$/.test(value) && value.length <= 10) {
      setMobile(value);
    }
  };

  const handleSubmit1 = async (e) => {
    e.preventDefault();

    if (mobile.length !== 10) {
      alert('Please Enter Valid Mobile Number');
      return;
    }

    setTime1(new Date());

    // Instantly show the next frame
    setShowInput1(false);
    setShowFrame1(true);

   
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleSubmit(event);
    }
  };

  const handleKeyDown1 = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleSubmit1(event);
    }
  };

  return (
    <>
      <div className="frame1 animated-frame">
        Please Enter Your Name:
        {showInput && (
          <div className="message fade-in">
            <input
              type="text"
              className="input-text2"
              placeholder="Enter your name"
              onKeyDown={handleKeyDown}
              value={name}
              onChange={handleChange}
              ref={nameInputRef}
            />
            <button className="submit-button" onClick={handleSubmit}></button>
          </div>
        )}
      </div>

      {showFrame && (
        <>
          <div className="you-time animated-frame">
            <img src={you} alt="boy" className="boy" />
            <div className="chatbot-time">{time.toLocaleTimeString()}</div>
          </div>

          <div className="you-message fade-in">
            <div className="frame2 animated-frame"><b>{name}</b></div>
          </div>

          <div className="chatbot animated-frame">
            <img src={bot} alt="bot" className="bot" />
            <div className="chatbot-time">{time.toLocaleTimeString()}</div>
          </div>

          <div className="frame1 animated-frame">
            Please Enter Your Mobile Number:
            {showInput1 && (
              <div className="message fade-in">
                <input
                  type="text"
                  className="input-text2"
                  placeholder="Enter Your Mobile Number"
                  value={mobile}
                  onKeyDown={handleKeyDown1}
                  onChange={handleChange1}
                  ref={mobileInputRef}
                  maxLength={10} // ✅ restrict input length
                />
                <button className="submit-button" onClick={handleSubmit1}></button>
              </div>
            )}
          </div>

          {showFrame1 && (
            <>
              <div className="you-time animated-frame">
                <img src={you} alt="boy" className="boy" />
                <div className="chatbot-time">{time1?.toLocaleTimeString()}</div>
              </div>

              <div className="you-message fade-in">
                <div className="frame2 animated-frame"><b>{mobile}</b></div>
              </div>

              <Mainmenu name={name} mobile={mobile} />
            </>
          )}
        </>
      )}
    </>
  );
};

export default Details;
